/* Mellow — Broadsheet Extended runtime. Enhances native forms/links; everything works without it (page cart, product pages). */
(function () {
  'use strict';
  var D = document, W = window;
  var CFG = W.MW || {};
  var ROUTES = CFG.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root_url: '/' };
  var STR = CFG.strings || {};
  var q = function (s, r) { return (r || D).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var isMobile = function () { return W.matchMedia('(max-width: 768px)').matches; };
  var reducedMotion = W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- toast ---------- */
  var toastTimer = null;
  function toast(text) {
    var el = q('[data-mw-toast]');
    if (!el) { el = D.createElement('div'); el.className = 'mw-toast'; el.setAttribute('data-mw-toast', ''); el.setAttribute('role', 'status'); D.body.appendChild(el); }
    el.textContent = text; el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.hidden = true; }, 1800);
  }

  /* ---------- cart drawer ---------- */
  var drawer = {
    el: function () { return q('[data-mw-drawer]'); },
    section: function () { return q('#shopify-section-mw-cart-drawer'); },
    lastFocus: null,
    open: function () {
      var el = this.el(); if (!el) { W.location.href = ROUTES.cart_url; return; }
      this.lastFocus = D.activeElement; el.hidden = false; D.body.classList.add('mw-drawer-open');
      var close = q('[data-mw-close-cart]', el); if (close) close.focus();
    },
    close: function () {
      var el = this.el(); if (!el || el.hidden) return;
      el.hidden = true; D.body.classList.remove('mw-drawer-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    isOpen: function () { var el = this.el(); return !!el && !el.hidden; },
    replace: function (html) {
      var wrap = this.section(); if (!wrap || !html) return;
      var wasOpen = this.isOpen();
      var tmp = D.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.firstElementChild && tmp.firstElementChild.id === wrap.id ? tmp.firstElementChild.innerHTML : html;
      wrap.innerHTML = inner;
      var el = this.el(); if (el) el.hidden = !wasOpen;
      var count = el ? Number(el.getAttribute('data-count') || 0) : null;
      if (count !== null) qa('[data-mw-cart-count]').forEach(function (n) {
        n.textContent = count;
        var icon = n.closest('[data-mw-bag]'); if (icon) icon.classList.toggle('mw-bag--count', count > 0), icon.classList.toggle('mw-bag--empty', count === 0);
      });
      init(wrap);
    }
  };
  D.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mw-open-cart]');
    if (open) { if (drawer.el()) { e.preventDefault(); drawer.open(); } return; }
    if (e.target.closest('[data-mw-close-cart]')) { e.preventDefault(); drawer.close(); return; }
    var el = drawer.el();
    if (el && !el.hidden && e.target === el) drawer.close();
  });
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer.isOpen()) { drawer.close(); return; }
    var z = q('[data-mw-zoom-overlay]'); if (z && !z.hidden) { hideZoom(); return; }
    qa('details.mw-nav__burger[open]').forEach(function (d) { d.open = false; });
  });

  /* ---------- add to cart (native form enhancement) ---------- */
  function setStatus(form, text, isError) {
    var s = q('[data-mw-status]', form); if (!s) return;
    s.textContent = text || ''; s.classList.toggle('mw-form__status--error', !!isError);
  }
  function addToCart(form) {
    var btn = q('[data-mw-add]', form) || q('button[type="submit"]', form);
    var fd = new FormData(form);
    var submitted = { variant_id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) || 1, selling_plan: fd.get('selling_plan') ? Number(fd.get('selling_plan')) : null, origin: form.getAttribute('data-mw-origin') || 'product-form' };
    if (!submitted.variant_id) { setStatus(form, STR.select_size || 'Select a size.', true); return; }
    fd.append('sections', 'mw-cart-drawer'); fd.append('sections_url', W.location.pathname);
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = STR.adding || 'ADDING…'; }
    setStatus(form, '');
    fetch(ROUTES.cart_add_url + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.json.description || res.json.message || (STR.add_error || 'Could not add this item.')); }
        var detail = { version: '1.0', submitted: submitted, response: res.json, origin: submitted.origin };
        D.dispatchEvent(new CustomEvent('spm:cart-added', { detail: detail, bubbles: true }));
        try { if (res.json.sections && res.json.sections['mw-cart-drawer']) drawer.replace(res.json.sections['mw-cart-drawer']); } catch (err) { /* drawer refresh failure must not become an add error */ }
        toast((STR.added || 'ADDED — ') + (res.json.product_title || ''));
        drawer.open();
      })
      .catch(function (err) { setStatus(form, err.message, true); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = label; } updateVariantButton(form); });
  }
  D.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-mw-ajax-cart]');
    if (!form || !W.fetch || !W.FormData) return;
    e.preventDefault(); addToCart(form);
  });

  /* ---------- quantity + remove (drawer) ---------- */
  function changeLine(key, quantity, line) {
    if (line) line.setAttribute('aria-busy', 'true');
    fetch(ROUTES.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'mw-cart-drawer', sections_url: W.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j.sections && j.sections['mw-cart-drawer']) drawer.replace(j.sections['mw-cart-drawer']); else W.location.reload(); })
      .catch(function () { if (line) line.removeAttribute('aria-busy'); });
  }
  D.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mw-qty]');
    if (btn) {
      var line = btn.closest('[data-mw-line]'); if (!line || !btn.closest('[data-mw-drawer]')) return;
      e.preventDefault();
      var input = q('[data-mw-qty-value]', line); var current = Number(input ? input.value : line.getAttribute('data-quantity')) || 1;
      changeLine(line.getAttribute('data-key'), Math.max(1, current + Number(btn.getAttribute('data-mw-qty'))), line);
      return;
    }
    var rm = e.target.closest('[data-mw-remove]');
    if (rm && rm.closest('[data-mw-drawer]')) { var l = rm.closest('[data-mw-line]'); e.preventDefault(); changeLine(l.getAttribute('data-key'), 0, l); }
  });

  /* ---------- one primary purchase action, driven by the selected variant's real availability ---------- */
  function variantState(form) {
    var data = null; var el = q('[data-mw-variants]', form);
    if (el) { try { data = JSON.parse(el.textContent); } catch (err) { data = null; } }
    if (el && el.getAttribute('data-mw-product-available') === 'false') return { state: 'soldout', id: '', title: '' };
    var checked = q('[data-mw-variant]:checked', form); var sel = q('[data-mw-variant-select]', form); var hidden = q('input[type="hidden"][name="id"]', form);
    var id = checked ? checked.value : (sel ? sel.value : (hidden ? hidden.value : ''));
    if (!id) return { state: 'none', id: '', title: '' };
    var v = data ? data[id] : null;
    var opt = sel && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
    var title = (v && v.title) || (checked ? checked.getAttribute('data-label') : (opt ? opt.getAttribute('data-label') : '')) || '';
    if ((v && v.available === false) || (!v && ((checked && checked.disabled) || (opt && opt.disabled)))) return { state: 'soldout', id: id, title: title };
    if (!v && !checked && !opt) return { state: 'unknown', id: id, title: title };
    return { state: 'available', id: id, title: title };
  }
  function setDisabled(btn, on) { btn.disabled = on; if (on) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled'); }
  function updateVariantButton(form) {
    var btn = q('[data-mw-add]', form); if (!btn) return;
    var so = q('[data-mw-soldout]', form); var pay = q('[data-mw-pay]', form);
    var s = variantState(form);
    if (s.state === 'unknown') return; /* no usable variant data: keep the server-rendered state */
    var payMode = btn.hasAttribute('data-mw-pay-mode') && !!pay && !form.hasAttribute('data-mw-pay-unavailable');
    if (s.state === 'soldout') { btn.hidden = true; setDisabled(btn, true); if (so) so.hidden = false; if (pay) pay.hidden = true; return; }
    if (so) so.hidden = true;
    if (s.state === 'none') { btn.hidden = false; setDisabled(btn, true); btn.textContent = btn.getAttribute('data-label-empty') || ''; if (pay) pay.hidden = true; return; }
    setDisabled(btn, false); btn.textContent = (btn.getAttribute('data-label-add') || '') + (btn.hasAttribute('data-needs-choice') && s.title ? ' — ' + s.title : '');
    if (payMode) { btn.hidden = true; pay.hidden = false; } else { btn.hidden = false; if (pay) pay.hidden = true; }
  }
  /* Shopify's accelerated checkout element (payment_button) after AJAX injection: ask the storefront runtime to initialise it,
     and fall back to ADD TO BAG when Shopify recommends no wallet for this buyer or the element never upgrades. */
  function initPaymentButtons(root) {
    var pays = qa('[data-mw-pay]', root || D); if (!pays.length) return;
    try { if (W.Shopify && W.Shopify.PaymentButton && typeof W.Shopify.PaymentButton.init === 'function') W.Shopify.PaymentButton.init(); } catch (err) {}
    pays.forEach(function (pay) {
      var form = pay.closest('form'); if (!form || pay.hasAttribute('data-mw-pay-checked')) return;
      pay.setAttribute('data-mw-pay-checked', '');
      var el = q('shopify-accelerated-checkout', pay); var rec = el ? el.getAttribute('recommended') : null;
      var unavailable = function () { form.setAttribute('data-mw-pay-unavailable', ''); updateVariantButton(form); };
      if (!el || !rec || rec === 'null' || rec === 'undefined') { unavailable(); return; }
      var tries = 0;
      (function check() {
        var upgraded = !!(W.customElements && W.customElements.get('shopify-accelerated-checkout')) || !!q('.shopify-payment-button__button:not([disabled])', pay) || !!el.shadowRoot;
        if (upgraded) { form.removeAttribute('data-mw-pay-unavailable'); updateVariantButton(form); return; }
        if (++tries < 24) setTimeout(check, 250); else unavailable();
      })();
    });
  }
  D.addEventListener('change', function (e) {
    var form = e.target.form || e.target.closest('form'); if (!form) return;
    if (e.target.matches('[data-mw-variant], [data-mw-variant-select]')) { updateVariantButton(form); var qv = form.closest('[data-mw-qv]'); if (qv) syncDetail(qv, form); }
    if (e.target.matches('[data-mw-filter-auto]') && form.hasAttribute('data-mw-filter-form')) navigateFilterForm(form);
    if (e.target.matches('[data-mw-view-select]')) applyView(e.target.closest('[data-mw-shop]'), e.target.value);
  });

  /* ---------- shop filter navigation keeps the page context ----------
     Filter/sort criteria live in sort_by, filter.* and page. Everything else in the current URL (view, open, preview, utm…) is
     unrelated and is carried over; page is always dropped when criteria change; a control only changes the state it owns. */
  var FILTER_PARAM = /^(sort_by|page|filter\.)/;
  function mergeFilterUrl(target, keepCriteria) {
    var out = new URL(target, W.location.href); var merged = new URLSearchParams(); var cur = new URL(W.location.href);
    cur.searchParams.forEach(function (v, k) { if (k === 'page') return; if (!keepCriteria && FILTER_PARAM.test(k)) return; if (out.searchParams.has(k)) return; merged.append(k, v); });
    out.searchParams.forEach(function (v, k) { if (k !== 'page') merged.append(k, v); });
    var qs = merged.toString(); out.search = qs ? '?' + qs : ''; return out.toString();
  }
  function hasParamValue(params, key) { return params.getAll(key).some(function (value) { return value !== ''; }); }
  function usesCurrentShopFilters(shop) {
    return shop && shop.getAttribute('data-mw-source') === 'current' && shop.getAttribute('data-mw-sort-enabled') === 'true' &&
      shop.getAttribute('data-mw-design-mode') !== 'true' && !(W.Shopify && W.Shopify.designMode);
  }
  /* Missing availability on arrival uses the section default; deliberately unchecking it means ALL. This theme-owned
     marker survives later category, sort and page changes, while a selected native availability always takes precedence. */
  function rememberAvailabilityChoice(target, control, allIfEmpty) {
    if (!usesCurrentShopFilters(control.closest('[data-mw-shop]'))) return target;
    var url = new URL(target, W.location.href);
    if (hasParamValue(url.searchParams, 'filter.v.availability')) url.searchParams.delete('mw_availability');
    else if (allIfEmpty) url.searchParams.set('mw_availability', 'all');
    return url.toString();
  }
  function preserveAvailabilityPagination(shop) {
    if (!usesCurrentShopFilters(shop)) return;
    var current; try { current = new URL(W.location.href); } catch (err) { return; }
    if (hasParamValue(current.searchParams, 'filter.v.availability')) return;
    if (!current.searchParams.has('filter.v.availability') && current.searchParams.getAll('mw_availability').indexOf('all') < 0) return;
    /* Shopify's native page URLs omit custom markers (and may omit empty filter values). Keep the shopper's ALL choice
       on those anchors without merging criteria: pagination must retain its own page number and native link behavior. */
    qa('[data-mw-pagination] a[href]', shop).forEach(function (a) {
      a.setAttribute('href', rememberAvailabilityChoice(a.getAttribute('href'), a, true));
    });
  }
  function navigateFilterForm(form) {
    if (!W.URLSearchParams || !W.FormData) { form.submit(); return; }
    var url = new URL(form.getAttribute('action') || W.location.pathname, W.location.href); var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { params.append(k, v); });
    url.search = params.toString() ? '?' + params.toString() : '';
    W.location.assign(rememberAvailabilityChoice(mergeFilterUrl(url.toString(), false), form, !!q('[name="filter.v.availability"]', form)));
  }
  D.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-mw-filter-form]'); if (!form) return;
    e.preventDefault(); navigateFilterForm(form);
  });
  /* Filter links keep native activation: the context-merged destination is written into the anchor's href just before the
     browser acts on it (mousedown covers left/middle/right-button and context-menu use, click covers keyboard Enter and
     synthetic activation), so plain clicks navigate this tab and Command/Ctrl/Shift/middle clicks open the same merged URL
     the native way. Nothing is intercepted and defaultPrevented / target / download stay the browser's business. */
  function refreshFilterLink(a) {
    var base = a.getAttribute('data-mw-href'); if (!base) { base = a.getAttribute('href') || ''; a.setAttribute('data-mw-href', base); }
    var clear = a.hasAttribute('data-mw-filter-clear');
    a.setAttribute('href', rememberAvailabilityChoice(mergeFilterUrl(base, !clear), a, clear));
  }
  function onFilterLinkActivation(e) {
    if (!W.URLSearchParams || !e.target.closest) return;
    var a = e.target.closest('a[data-mw-filter-link]'); if (a) refreshFilterLink(a);
  }
  D.addEventListener('mousedown', onFilterLinkActivation, true);
  D.addEventListener('click', onFilterLinkActivation, true);

  /* ---------- nav burger ---------- */
  D.addEventListener('click', function (e) {
    var open = qa('details.mw-nav__burger[open]'); if (!open.length) return;
    open.forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });

  /* ---------- shop split: panels, views, quick view ---------- */
  function showPanel(root, name) {
    qa('[data-mw-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-mw-panel') !== name; });
    var t = q('[data-mw-filter-toggle]', root); if (t) t.setAttribute('aria-expanded', name === 'filter' ? 'true' : 'false');
    if (isMobile()) { var split = q('[data-m="split"]', root); if (split) split.scrollTop = 0; W.scrollTo(0, 0); }
  }
  function colsFor(root, view) {
    var wrap = q('[data-mw-grid-wrap]', root); var count = Number(wrap ? wrap.getAttribute('data-count') : 0);
    if (view === 'ALL') return count <= 6 ? 3 : 9;
    return parseInt(view, 10) || 3;
  }
  function applyView(root, view, persist) {
    if (!root) return;
    var wrap = q('[data-mw-grid-wrap]', root); var grid = q('[data-mw-grid]', root); if (!wrap || !grid) return;
    var cols = colsFor(root, view);
    wrap.setAttribute('data-view', view); wrap.setAttribute('data-cols', cols); grid.setAttribute('data-cols', cols);
    wrap.style.setProperty('--cols', cols); grid.setAttribute('data-m', cols >= 6 ? 'grid-dense' : 'grid');
    qa('[data-mw-view]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mw-view') === view ? 'true' : 'false'); });
    if (persist === false) return;
    try { sessionStorage.setItem('mw-view-' + (root.getAttribute('data-mw-shop') || 'shop'), view); } catch (err) {}
  }
  /* Phones keep their own VIEW 1 / 2 preference (data-mobile-view on the grid wrap); the desktop 2 / 4 / ALL state stays on
     data-view / data-cols. The stylesheet's phone block reads only data-mobile-view, so a saved desktop ALL can never shrink
     phone images, and resizing or rotating simply switches which attribute the CSS honours. */
  function applyMobileView(root, view, persist) {
    if (!root) return; var wrap = q('[data-mw-grid-wrap]', root); if (!wrap) return;
    view = view === '1' ? '1' : '2'; wrap.setAttribute('data-mobile-view', view);
    qa('[data-mw-mobile-view]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mw-mobile-view') === view ? 'true' : 'false'); });
    if (persist === false) return;
    try { sessionStorage.setItem('mw-mview-' + (root.getAttribute('data-mw-shop') || 'shop'), view); } catch (err) {}
  }
  D.addEventListener('click', function (e) {
    var root = e.target.closest('[data-mw-shop]'); if (!root) return;
    var mview = e.target.closest('[data-mw-mobile-view]');
    if (mview) { e.preventDefault(); applyMobileView(root, mview.getAttribute('data-mw-mobile-view')); return; }
    var toggle = e.target.closest('[data-mw-filter-toggle]');
    if (toggle) { e.preventDefault(); var filterOpen = toggle.getAttribute('aria-expanded') === 'true'; showPanel(root, filterOpen ? (root.getAttribute('data-mw-left') || 'hero') : 'filter'); return; }
    var view = e.target.closest('[data-mw-view]');
    if (view) { e.preventDefault(); applyView(root, view.getAttribute('data-mw-view')); return; }
    var exit = e.target.closest('[data-mw-exit]');
    if (exit) { e.preventDefault(); closeQuickView(root); return; }
    var card = e.target.closest('[data-mw-quick-view]');
    if (card && q('[data-mw-panel="product"]', root) && W.fetch) { e.preventDefault(); openQuickView(root, card.getAttribute('href'), card.getAttribute('data-mw-quick-view')); return; }
    var issue = e.target.closest('[data-mw-issue]');
    if (issue && q('[data-mw-issue-template="' + issue.getAttribute('data-mw-issue') + '"]', root)) { e.preventDefault(); openIssue(root, issue.getAttribute('data-mw-issue')); }
  });
  function setOpenParam(value) {
    try { var u = new URL(W.location.href); if (value) u.searchParams.set('open', value); else u.searchParams.delete('open'); history.replaceState(null, '', u.toString()); } catch (err) {}
  }
  var reqSeq = 0; /* every open / close / section unload bumps the root's request token and aborts its in-flight fetch;
                     a late response is also dropped when its root is no longer in the document (Theme Editor section replacement) */
  function invalidateRequests(root) {
    root.setAttribute('data-mw-req', String(++reqSeq));
    if (root.__mwAbort) { try { root.__mwAbort.abort(); } catch (err) {} root.__mwAbort = null; }
  }
  function openQuickView(root, url, handle) {
    var panel = q('[data-mw-panel="product"]', root); if (!panel) return;
    invalidateRequests(root);
    var token = root.getAttribute('data-mw-req');
    var ctrl = W.AbortController ? new W.AbortController() : null; root.__mwAbort = ctrl;
    var live = function () { return D.contains(root) && root.getAttribute('data-mw-req') === token; };
    var sectionId = root.getAttribute('data-mw-quick-view-section') || 'mw-product-quick-view';
    panel.innerHTML = '<div class="mw-qv" data-mw-qv data-mw-loading><div class="mw-exit" data-m="exit"><a class="mw-exit__btn" href="#" data-mw-exit>&#x2715; ' + (STR.close || 'CLOSE') + '</a><span class="mw-qv__loading" aria-busy="true">' + (STR.loading || 'LOADING…') + '</span></div></div>';
    showPanel(root, 'product'); root.setAttribute('data-mw-left', 'product');
    var u = url.split('#')[0]; u += (u.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
    fetch(u, { headers: { 'Accept': 'text/html' }, signal: ctrl ? ctrl.signal : undefined }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      if (!live()) return; /* stale: a newer product, CLOSE or a section unload won, or the section was replaced */
      var tmp = D.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.firstElementChild ? tmp.firstElementChild.innerHTML : html;
      panel.innerHTML = inner; init(panel); initPaymentButtons(panel); setOpenParam(handle);
      try { panel.focus({ preventScroll: true }); } catch (err) {}
    }).catch(function (err) { if (err && err.name === 'AbortError') return; if (live()) W.location.href = url; });
  }
  /* CLOSE restores the configured default panel (Photo or Featured product details); it never scrolls the right grid. */
  function closeQuickView(root) {
    invalidateRequests(root);
    root.setAttribute('data-mw-left', 'hero'); showPanel(root, 'hero'); setOpenParam('');
    var closed = q('[data-mw-panel="product"]', root); if (closed) closed.innerHTML = '';
    var right = q('[data-mw-mag-right]', root); if (right) { qa('[data-mw-mag-stage]', right).forEach(function (s) { s.remove(); }); var grid = q('[data-mw-mag-grid]', right); if (grid) grid.hidden = false; var bar = q('[data-mw-filterbar]', root); if (bar) bar.hidden = false; }
  }
  /* magazine issue quick view (markup comes from a <template> per issue block, rendered by Liquid) */
  function openIssue(root, id) {
    var tpl = q('[data-mw-issue-template="' + id + '"]', root); var panel = q('[data-mw-panel="issue"]', root); var right = q('[data-mw-mag-right]', root);
    if (!tpl || !panel || !right) return;
    var frag = tpl.content.cloneNode(true);
    var left = q('[data-mw-issue-left]', frag); var stage = q('[data-mw-mag-stage]', frag);
    panel.innerHTML = ''; if (left) panel.appendChild(left);
    qa('[data-mw-mag-stage]', right).forEach(function (s) { s.remove(); });
    var grid = q('[data-mw-mag-grid]', right); if (grid) grid.hidden = true;
    var bar = q('[data-mw-filterbar]', root); if (bar) bar.hidden = true;
    if (stage) { right.appendChild(stage); initStage(stage); }
    showPanel(root, 'issue'); root.setAttribute('data-mw-left', 'issue'); setOpenParam(id);
    try { panel.focus({ preventScroll: true }); } catch (err) {}
  }
  function initStage(stage) {
    var slides = qa('[data-mw-slide]', stage); if (!slides.length) return;
    var i = 0, n = slides.length;
    var dots = qa('[data-mw-dot]', stage), label = q('[data-mw-stage-label]', stage), counter = q('[data-mw-stage-count]', stage), frame = q('[data-mw-stage-frame]', stage);
    function show(k) {
      i = (k + n) % n;
      slides.forEach(function (s, j) { s.hidden = j !== i; });
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (label) label.textContent = slides[i].getAttribute('data-label') || '';
      if (counter) counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
      if (frame) frame.classList.toggle('mw-stage--covers', slides[i].getAttribute('data-kind') === 'covers');
    }
    stage.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-mw-prev]'), next = e.target.closest('[data-mw-next]'), dot = e.target.closest('[data-mw-dot]');
      if (prev) { e.stopPropagation(); show(i - 1); return; }
      if (next) { e.stopPropagation(); show(i + 1); return; }
      if (dot) { e.stopPropagation(); show(dots.indexOf(dot)); return; }
      var img = e.target.closest('img'); if (img && e.target.closest('[data-mw-stage-frame]')) showZoom(img.currentSrc || img.src);
    });
    show(0);
  }

  /* ---------- zoom overlay ---------- */
  function overlay() {
    var z = q('[data-mw-zoom-overlay]');
    if (!z) { z = D.createElement('div'); z.className = 'mw-zoom'; z.hidden = true; z.setAttribute('data-mw-zoom-overlay', ''); z.innerHTML = '<img alt="">'; D.body.appendChild(z); z.addEventListener('click', hideZoom); }
    return z;
  }
  function showZoom(src) { if (!src) return; var z = overlay(); q('img', z).src = src; z.hidden = false; }
  function hideZoom() { var z = q('[data-mw-zoom-overlay]'); if (z) z.hidden = true; }
  D.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mw-zoom]'); if (!t || e.target.closest('[data-mw-stage-frame]')) return;
    var img = t.tagName === 'IMG' ? t : q('img', t); if (!img) return;
    e.preventDefault(); showZoom(t.getAttribute('data-mw-zoom') || img.currentSrc || img.src);
  });

  /* ---------- quick view thumbs + selected-variant details (price, compare-at, low stock, variant image) ----------
     Everything is scoped to one [data-mw-qv] panel: the change event's own form decides which panel updates, so the hidden
     Featured panel and the visible quick view never touch each other. */
  function showThumb(qv, th) {
    var main = q('[data-mw-qv-main] img', qv); if (!main || !th) return;
    main.src = th.getAttribute('data-mw-thumb'); main.removeAttribute('srcset'); main.removeAttribute('sizes');
    qa('[data-mw-thumb]', qv).forEach(function (t) { t.setAttribute('aria-current', t === th ? 'true' : 'false'); });
  }
  D.addEventListener('click', function (e) {
    var th = e.target.closest('[data-mw-thumb]'); if (!th) return;
    var qv = th.closest('[data-mw-qv]'); if (qv) showThumb(qv, th);
  });
  function syncDetail(qv, form) {
    var el = q('[data-mw-qv-variants]', qv); if (!el) return;
    var data; try { data = JSON.parse(el.textContent) || {}; } catch (err) { return; }
    form = form || q('form[data-mw-ajax-cart]', qv); if (!form) return;
    var s = variantState(form); var v = s.id ? data[s.id] : null;
    var price = q('[data-mw-qv-price]', qv);
    if (price && v && v.price) { price.textContent = ''; if (v.compare) { var del = D.createElement('s'); del.textContent = v.compare; price.appendChild(del); price.appendChild(D.createTextNode(' ')); } price.appendChild(D.createTextNode(v.price)); }
    var stock = q('[data-mw-qv-stock]', qv);
    if (stock) { var low = v && typeof v.low === 'number' && v.low > 0 ? v.low : 0; if (low) { stock.textContent = low === 1 ? (stock.getAttribute('data-last') || '') : (stock.getAttribute('data-only') || '').replace('__N__', String(low)); stock.hidden = false; } else { stock.textContent = ''; stock.hidden = true; } }
    if (v && v.media) { var th = qa('[data-mw-thumb]', qv).filter(function (t) { return t.getAttribute('data-mw-media') === String(v.media); })[0]; if (th) showThumb(qv, th); }
  }

  /* ---------- youtube landing: embedded player ----------
     Poster facade (the approved artwork + PLAY) → on PLAY the YouTube embed is injected with autoplay (a user gesture, so the
     browser allows it) or the native <video> starts; nothing autoplays on load. Loading / unavailable states are driven by the
     media element's own events and, for YouTube, by the player's postMessage events (enablejsapi). */
  var YT_ORIGINS = { 'https://www.youtube-nocookie.com': 1, 'https://www.youtube.com': 1 }; var VIMEO_ORIGIN = 'https://player.vimeo.com';
  function videoState(root, text) { var el = q('[data-mw-video-state]', root); if (!el) return; if (text) { el.textContent = text; el.hidden = false; } else { el.hidden = true; } }
  function videoStatus(root, status) { root.setAttribute('data-mw-video-status', status); if (status !== 'loading') videoState(root, status === 'unavailable' ? (STR.video_unavailable || 'VIDEO UNAVAILABLE') : ''); }
  function videoUnavailable(root) {
    videoStatus(root, 'unavailable');
    var poster = q('[data-mw-video-poster]', root); if (poster) { poster.hidden = false; var b = q('[data-mw-video-play]', poster); if (b) b.hidden = true; }
    var stage = q('[data-mw-video-stage]', root); if (stage && poster) stage.hidden = true;
  }
  function listenToPlayer(root, frame) {
    var kind = root.getAttribute('data-mw-video-kind');
    try {
      if (kind === 'vimeo') { ['play', 'pause', 'ended', 'error', 'loaded'].forEach(function (ev) { frame.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: ev }), VIMEO_ORIGIN); }); }
      else frame.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: root.getAttribute('data-mw-video-id') || 'mw', channel: 'widget' }), '*');
    } catch (err) {}
  }
  /* Definitive provider answers only: a 400/401/403/404 from the official oEmbed endpoint means unknown / private / removed / embedding
     denied → VIDEO UNAVAILABLE before PLAY. Network or CORS failures never block playback. */
  function probeEmbed(root) {
    var url = root.getAttribute('data-mw-video-oembed'); if (!url || !W.fetch) return;
    fetch(url, { mode: 'cors', credentials: 'omit' }).then(function (res) { if (res.status === 400 || res.status === 401 || res.status === 403 || res.status === 404) videoUnavailable(root); }).catch(function () {});
  }
  function playVideo(root) {
    var stage = q('[data-mw-video-stage]', root), poster = q('[data-mw-video-poster]', root); if (!stage) return;
    if (root.getAttribute('data-mw-video-status') === 'unavailable') return;
    stage.hidden = false; if (poster) poster.hidden = true;
    videoStatus(root, 'loading'); videoState(root, STR.loading || 'LOADING…');
    var kind = root.getAttribute('data-mw-video-kind');
    if (kind === 'youtube' || kind === 'vimeo') {
      var f = q('[data-mw-video-iframe]', stage);
      if (!f) {
        f = D.createElement('iframe'); f.className = 'mw-video__frame'; f.setAttribute('data-mw-video-iframe', '');
        f.title = root.getAttribute('data-mw-video-title') || 'Video';
        f.setAttribute('allow', kind === 'vimeo' ? 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media' : 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen');
        f.setAttribute('allowfullscreen', ''); f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        f.addEventListener('load', function () { listenToPlayer(root, f); });
        var src = root.getAttribute('data-mw-video-embed') || '';
        /* YouTube only talks back (enablejsapi) when origin= is the page's real origin, so it is set here, not in Liquid */
        if (kind === 'youtube') src += '&origin=' + encodeURIComponent(W.location.origin);
        f.src = src + '&autoplay=1' + (root.getAttribute('data-mw-video-fragment') || ''); stage.appendChild(f);
      }
      setTimeout(function () { if (root.getAttribute('data-mw-video-status') === 'loading') videoStatus(root, 'ready'); }, 6000);
    } else {
      var v = q('video', stage); if (!v) return;
      var p = v.play(); if (p && p.catch) p.catch(function () { if (root.getAttribute('data-mw-video-status') === 'loading') videoStatus(root, 'ready'); });
    }
  }
  function mediaFailed(v) { return !!(v.error) || (v.networkState === 3 && v.readyState === 0); }
  function initVideo(root) {
    if (root.mwVideoInit) return; root.mwVideoInit = true; root.setAttribute('data-mw-video-init', '');
    var v = q('video', root), f = q('[data-mw-video-iframe]', root);
    if (v) {
      v.addEventListener('error', function () { videoUnavailable(root); });
      qa('source', v).forEach(function (src) { src.addEventListener('error', function () { if (!src.nextElementSibling) videoUnavailable(root); }); });
      /* a 404 / non-media response can already have failed before this runs (preload="metadata" starts at parse time) */
      if (mediaFailed(v)) videoUnavailable(root); else setTimeout(function () { if (mediaFailed(v)) videoUnavailable(root); }, 1500);
      v.addEventListener('loadeddata', function () { if (root.getAttribute('data-mw-video-status') === 'loading') videoStatus(root, 'ready'); });
      v.addEventListener('waiting', function () { videoState(root, STR.loading || 'LOADING…'); });
      v.addEventListener('playing', function () { videoStatus(root, 'playing'); });
      v.addEventListener('pause', function () { videoStatus(root, 'paused'); });
      v.addEventListener('ended', function () { videoStatus(root, 'ended'); });
      if (root.getAttribute('data-mw-video-cover') === 'player') videoStatus(root, 'ready');
    }
    if (f) { videoStatus(root, 'ready'); if (f.contentWindow) listenToPlayer(root, f); f.addEventListener('load', function () { listenToPlayer(root, f); }); }
    probeEmbed(root);
    var play = q('[data-mw-video-play]', root); if (play) play.addEventListener('click', function (e) { e.preventDefault(); playVideo(root); });
    var poster = q('[data-mw-video-poster]', root); if (poster) poster.addEventListener('click', function (e) { if (!e.target.closest('[data-mw-video-play]')) playVideo(root); });
  }
  W.addEventListener('message', function (e) {
    var vimeo = e.origin === VIMEO_ORIGIN; if (!YT_ORIGINS[e.origin] && !vimeo) return;
    var data = e.data; if (typeof data === 'string') { try { data = JSON.parse(data); } catch (err) { return; } }
    if (!data || !data.event) return;
    var root = null; qa('[data-mw-video][data-mw-video-kind="' + (vimeo ? 'vimeo' : 'youtube') + '"]').forEach(function (r) { var f = q('[data-mw-video-iframe]', r); if (f && f.contentWindow === e.source) root = r; });
    if (!root) return;
    if (vimeo) {
      if (data.event === 'ready') { listenToPlayer(root, q('[data-mw-video-iframe]', root)); if (root.getAttribute('data-mw-video-status') === 'loading') videoStatus(root, 'ready'); }
      else if (data.event === 'play') videoStatus(root, 'playing');
      else if (data.event === 'pause') videoStatus(root, 'paused');
      else if (data.event === 'ended') videoStatus(root, 'ended');
      else if (data.event === 'error') videoUnavailable(root);
      else if (data.event === 'loaded' && root.getAttribute('data-mw-video-status') === 'loading') videoStatus(root, 'ready');
      return;
    }
    if (data.event === 'onError') { videoUnavailable(root); return; }
    var state = null;
    if (data.event === 'onStateChange') state = data.info;
    else if (data.event === 'infoDelivery' && data.info && typeof data.info.playerState === 'number') state = data.info.playerState;
    if (state === 1) videoStatus(root, 'playing');
    else if (state === 2) videoStatus(root, 'paused');
    else if (state === 0) videoStatus(root, 'ended');
    else if (root.getAttribute('data-mw-video-status') === 'loading' && (data.event === 'onReady' || state === 5 || state === -1 || state === 3)) videoStatus(root, 'ready');
  });

  /* The editor keeps its current preview URL. Shopify must filter and sort the full collection before pagination. Apply
     missing defaults together, retaining explicit criteria, tag/locale paths, page, repeated parameters and deep links. */
  function shopRoots(scope) {
    var shops = qa('[data-mw-shop]', scope);
    if (scope.matches && scope.matches('[data-mw-shop]')) shops.unshift(scope);
    return shops;
  }
  function applyDefaultShopSort(scope) {
    var shops = shopRoots(scope);
    var supported = ['created-descending', 'created-ascending', 'price-ascending', 'price-descending', 'title-ascending', 'title-descending', 'best-selling', 'manual'];
    for (var i = 0; i < shops.length; i++) {
      var shop = shops[i];
      if (shop.mwDefaultSortPending) return true;
      if (!usesCurrentShopFilters(shop)) continue;
      var url; try { url = new URL(W.location.href); } catch (err) { continue; }
      var changed = false, desired = shop.getAttribute('data-mw-default-sort');
      if (supported.indexOf(desired) >= 0 && desired !== shop.getAttribute('data-mw-collection-sort') && !hasParamValue(url.searchParams, 'sort_by')) {
        url.searchParams.set('sort_by', desired); changed = true;
      }
      var availability = shop.getAttribute('data-mw-default-availability');
      if ((availability === 'in-stock' || availability === 'out-of-stock') && !url.searchParams.has('filter.v.availability') && url.searchParams.getAll('mw_availability').indexOf('all') < 0) {
        url.searchParams.set('filter.v.availability', availability === 'in-stock' ? '1' : '0'); changed = true;
      }
      if (!changed) continue;
      shop.mwDefaultSortPending = true;
      W.location.replace(url.toString());
      return true;
    }
    return false;
  }

  /* ---------- init ---------- */
  function init(root) {
    root = root || D;
    if (applyDefaultShopSort(root)) return;
    var hdr = q('[data-mw-header]'); if (hdr) { var stickyHdr = hdr.classList.contains('mw-nav--sticky'); var hdrWrap = hdr.closest('.shopify-section'); if (hdrWrap) hdrWrap.classList.toggle('mw-header-section--sticky', stickyHdr); D.body.classList.toggle('mw-has-sticky-header', stickyHdr); }
    qa('form[data-mw-ajax-cart]', root).forEach(updateVariantButton);
    qa('[data-mw-qv]', root).forEach(function (qv) { syncDetail(qv); });
    initPaymentButtons(root);
    shopRoots(root).forEach(function (shop) {
      preserveAvailabilityPagination(shop);
      var wrap = q('[data-mw-grid-wrap]', shop);
      /* A locked grid (magazine with "Show view selector" off) keeps the server-rendered single column on every screen and never
         reads or writes the saved VIEW preferences, so a stale phone "2" or desktop "ALL" cannot come back while the selector is hidden. */
      var lock = shop.getAttribute('data-mw-view-lock');
      if (wrap && lock) { applyView(shop, lock, false); applyMobileView(shop, lock, false); }
      else if (wrap) {
        var saved = null; try { saved = sessionStorage.getItem('mw-view-' + (shop.getAttribute('data-mw-shop') || 'shop')); } catch (err) {}
        var views = qa('[data-mw-view]', shop).map(function (b) { return b.getAttribute('data-mw-view'); });
        applyView(shop, saved && views.indexOf(saved) >= 0 ? saved : wrap.getAttribute('data-view'));
        var savedMobile = null; try { savedMobile = sessionStorage.getItem('mw-mview-' + (shop.getAttribute('data-mw-shop') || 'shop')); } catch (err) {}
        applyMobileView(shop, savedMobile === '1' || savedMobile === '2' ? savedMobile : (wrap.getAttribute('data-mobile-view') || '2'));
      }
      var params; try { params = new URLSearchParams(W.location.search); } catch (err) { params = null; }
      var open = params && params.get('open');
      if (open && !shop.hasAttribute('data-mw-opened')) {
        shop.setAttribute('data-mw-opened', '');
        if (q('[data-mw-issue-template="' + open + '"]', shop)) openIssue(shop, open);
        else if (q('[data-mw-panel="product"]', shop)) { var card = q('[data-mw-quick-view="' + open + '"]', shop); openQuickView(shop, card ? card.getAttribute('href') : (ROUTES.root_url.replace(/\/$/, '') + '/products/' + encodeURIComponent(open)), open); }
      }
    });
    qa('[data-mw-mag-stage]', root).forEach(function (s) { if (!s.hasAttribute('data-mw-stage-ready')) { s.setAttribute('data-mw-stage-ready', ''); initStage(s); } });
    qa('[data-mw-video]', root).forEach(initVideo);
    var drawerEl = drawer.el(); if (drawerEl && drawerEl.getAttribute('data-open-on-load') === 'true' && !D.body.hasAttribute('data-mw-drawer-autoloaded')) { D.body.setAttribute('data-mw-drawer-autoloaded', ''); }
  }
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
  W.addEventListener('pageshow', function (e) { if (e.persisted) { qa('[data-mw-shop]').forEach(function (s) { s.removeAttribute('data-mw-opened'); }); init(D); } });
  D.addEventListener('shopify:section:unload', function (e) {
    hideZoom();
    var t = e.target; if (!t || !t.querySelectorAll) return;
    if (t.matches && t.matches('[data-mw-shop]')) invalidateRequests(t);
    qa('[data-mw-shop]', t).forEach(invalidateRequests);
  });
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { init(D); }); else init(D);
  W.MellowTheme = { openCart: function () { drawer.open(); }, closeCart: function () { drawer.close(); }, init: init, reducedMotion: reducedMotion };
})();
